import {Injectable} from "@angular/core";
import {CONFIG} from "../config";
import {map} from "rxjs/operator/map";
import {Observable} from "rxjs";


@Injectable()
export class WindowService {

    private screenZoom = 1.0;
    private aspectRatio = 1.6;
    private originOffset = 0;

    constructor() {
        this.screenZoom = this.getScreenHeight() / CONFIG.defaultScreenHeight;
        // this.aspectRatio = window.innerWidth/window.innerHeight;
        window.addEventListener("resize", ()=> {
            this.screenZoom = this.getScreenHeight() / CONFIG.defaultScreenHeight;
            this.scale();
          
        });
        // this.scale();
    }

    viewport() {
        // var e = window
        //     , a = 'inner';
        // if (!( 'innerWidth' in window )) {
        //     a = 'client';
        //     e = document.documentElement || document.body;
        // }
        let a = 'client';
        let e = document.documentElement || document.body;
        return {width: e[a + 'Width'], height: e[a + 'Height']}
    }

    scale(container = null) {
        if (!container) {
            container = window.document.body;
        }
        let width = this.convertSize(this.getMainContainerWidth());

        let header = window.document.querySelector('.main-header') as HTMLElement;
        let footer = window.document.querySelector('.main-footer') as HTMLElement;
        if (header) {
            header.style.width = width + 'px';
        }
        if (footer) {
            footer.style.width = width + 'px';
            footer.style.marginLeft = -1 * width / 2 + 'px';
        }
        // container.style.width = width + 'px';
        // container.style.height = height + 'px';
        // container.style.zoom = this.screenZoom;
        this.originOffset = this.convertSize(((this.getScreenWidth() - this.getMainContainerWidth()) / 2));
        let metric = 'px';
        switch(this.getScreenWidth()) {
            case 1920:
                this.originOffset = 50;
                metric = '%';
                break;
            case 1680:
                this.originOffset = 20;
                metric = '%';
                break;
        }
        if(this.getRealAspectRatio() == this.getAspectRatio()){
            this.originOffset = 0;
        }
        // this.originOffset = this.calculateContainerOffset();
        container.style.width = this.convertSize(this.getMainContainerWidth()) + 'px';
        container.style.height = this.convertSize(this.getScreenHeight()) + 'px';
        container.style['transform-origin'] = this.originOffset + metric + " 0 0 ";
        container.style.transform = "scale(" + this.screenZoom + ")";
        // container.parentElement.style['position'] = "relative";
        // alert(1)
    }

    calculateContainerOffset(){
        let matrix = {
            1.60: 0,
            1.66: 2,
            1.75: 20,
            1.77: 5,
            1.78: 5,
            1.80: 6,
            1.95: 8,
            2.00: 9,
            2.10: 10

        };

        let aspectRatio = this.getRealAspectRatio().toFixed(2);
       // alert(aspectRatio);
        // return matrix[aspectRatio] ? matrix[aspectRatio] : 0;
        //return Math.round(19.455*aspectRatio - 29.9729);
        return 50;

    }

    getMainContainerWidth() {
        let width = Math.ceil(this.getScreenHeight() * this.getAspectRatio());
        if (this.getRealAspectRatio() < this.getAspectRatio()) {
            width = this.getScreenWidth();
        }

        return width;
    }

    getAspectRatio() {
        return CONFIG.aspectRatio;
    }

    getRealAspectRatio() {
        return this.getScreenWidth() / this.getScreenHeight();
    }

    getOriginOffset() {
        return this.originOffset;
    }

    getScreenZoom():number {
        return this.screenZoom;
    }

    getXScale():number {
        return parseFloat((this.getMainContainerWidth() / CONFIG.defaultScreenWidth).toFixed(2));
    }

    getYScale():number {
        return parseFloat((this.getScreenHeight() / CONFIG.defaultScreenHeight).toFixed(2));
    }

    getScreenWidth():number {
        return this.viewport().width;
    }


    getScreenHeight():number {
        let height = this.viewport().height;
        if (this.getScreenWidth() / height < 1) {
            return this.getScreenWidth() / this.getAspectRatio();
        }
        return height;
    }

    convertSize(size) {
        return size / this.screenZoom;
    }


    addResizeEventListener(fn:EventListener) {
        window.addEventListener("resize", fn);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/window.service.ts